var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-wrap"},_vm._l((_vm.tabData),function(item,index){return _c('div',{key:'tabs' + index,class:_vm.currentClick == item.value ? 'active-tab-class tab-class' : 'tab-class',on:{"click":function($event){return _vm.tabClick(item.value)}}},[_c('span',[_vm._v(_vm._s(item.label))]),_c('span',{staticClass:"line"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }